import { DARK_THEME } from '../constants'
import {createAction} from "redux-actions";

export const darkTheme = createAction(DARK_THEME);